
import { Link } from "react-router-dom";
import useFetchFaq from "../../lib/hooks/use-fetch-faq";
import AllFaq from "./ui/all-faq";

//
export default  function FaqList() {
  
  const {data}=useFetchFaq();
  const page = data.status
    ? data.data
    : { title: "FAQ", description: "Error fetching page" }; 
  return (
    <>
      <div className="dashboard-page-title">
        <div className="breadcrumbs">
          <Link to="/admin">Dashboard</Link>
          <span>FAQ</span>
        </div>
      </div>

      {data.status && <AllFaq page={page} />}
    </>
  );
}
